import { css } from '@emotion/core';
import { tokens } from '@domain-group/design-tokens';
import animations from './animations';
import fontFace from './font';
import normalize from './normalize';
import applyFont from '../typography/apply-font';
var globalStyles = /*#__PURE__*/css(fontFace, ";", normalize, ";html{box-sizing:border-box;}*,*::before,*::after{box-sizing:inherit;}body{background-color:", tokens.colors.neutral.surface.default, ";", applyFont(tokens.typography.body), ";color:", tokens.colors.neutral.heavy.default, ";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-size-adjust:100%;-webkit-text-size-adjust:100%;}", animations);
export default globalStyles;